import React from "react";

// Renders the couple monogram in one of several ready-made styles.
// size is a number (px) for the base glyph size.
export const Monogram = ({ data, size = 62, className = "" }) => {
  const c = data.colors;
  if (data.logoImage) {
    return (
      <img
        src={data.logoImage}
        alt="monogram"
        className={className}
        style={{ width: size * 2.4, height: size * 2.4, objectFit: "contain", display: "block", marginLeft: "auto", marginRight: "auto" }}
        data-testid="monogram"
        data-style="logo"
      />
    );
  }
  const initials = (data.monogram || "").trim() || `${data.groomName?.[0] || ""}${data.brideName?.[0] || ""}`;
  const style = data.monogramStyle || "plain";
  const letters = initials.replace(/[\s&]/g, "").split("");
  const a = letters[0] || initials.charAt(0) || "M";
  const b = letters[1] || letters[0] || "M";

  if (style === "ampersand") {
    return (
      <span className={`font-monogram ${className}`} style={{ fontSize: size, color: c.accent, lineHeight: 1, display: "inline-flex", alignItems: "center" }} data-testid="monogram" data-style="ampersand">
        <span className="italic">{a}</span>
        <span className="italic" style={{ fontSize: size * 0.6, color: c.secondary, margin: `0 ${size * 0.08}px`, transform: "translateY(-2px)" }}>&amp;</span>
        <span className="italic">{b}</span>
      </span>
    );
  }

  if (style === "interlocked") {
    return (
      <span className={`font-monogram italic ${className}`} style={{ fontSize: size, color: c.accent, lineHeight: 1, display: "inline-flex", alignItems: "flex-end" }} data-testid="monogram" data-style="interlocked">
        <span style={{ transform: "translateY(-6%)" }}>{a}</span>
        <span style={{ marginLeft: `-${size * 0.3}px`, color: c.secondary, opacity: 0.9, transform: "translateY(10%)" }}>{b}</span>
      </span>
    );
  }

  if (style === "crest") {
    const box = size * 1.7;
    return (
      <span className={`relative inline-flex items-center justify-center ${className}`} style={{ width: box, height: box }} data-testid="monogram" data-style="crest">
        <span className="absolute inset-0 rounded-full" style={{ border: `2px solid ${c.accent}` }} />
        <span className="absolute rounded-full" style={{ inset: size * 0.12, border: `1px solid ${c.accent}66` }} />
        <span className="absolute rotate-45" style={{ top: -size * 0.1, left: "50%", marginLeft: -size * 0.09, width: size * 0.18, height: size * 0.18, background: c.accent }} />
        <span className="absolute rotate-45" style={{ bottom: -size * 0.1, left: "50%", marginLeft: -size * 0.09, width: size * 0.18, height: size * 0.18, background: c.accent }} />
        <span className="font-monogram italic" style={{ fontSize: size * 0.82, color: c.accent, lineHeight: 1 }}>{initials}</span>
      </span>
    );
  }

  return (
    <span className={`font-monogram italic ${className}`} style={{ fontSize: size, color: c.accent, lineHeight: 1 }} data-testid="monogram" data-style="plain">
      {initials}
    </span>
  );
};
